import React from "react";
import ReactDOM from "react-dom";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "smartbanner.js";
import "../../../vendor/assets/stylesheets/intlTelInput.css";
import "../stylesheets/application.scss";
import ScrollTopButton from "../components/common/ScrollTopButton";
import { xlsxExport } from "../utils/xlsxExport";

var componentRequireContext = require.context("modules", true);
var ReactRailsUJS = require("react_ujs");

ReactRailsUJS.useContext(componentRequireContext);

/**
 *
 * @param chartName String
 * @param linkNames String
 * @param fromContext Boolean|Null
 */
let animationNonReactChart = function (chartName, linkNames, fromContext) {
  const loader = `<div class="md-cs-loader bg"><div class="md-cs-loader-inner"><div class="stairs-up-loader"><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__ball"></div></div><p>Updating data...</p></div></div>`;
  $(document).on("click", `${linkNames}`, function () {
    let chartNameSelector = chartName;
    if (fromContext) {
      chartNameSelector = $(this).context.dataset.chartName;
    }
    $("#" + chartNameSelector)
      .find(".md-cs-loader")
      .remove();
    $("#" + chartNameSelector).append(loader);
  });
};

window.xlsxROR = function (data, headers) {
  xlsxExport({ data, headers, fileName: "raw_data" });
};

window.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(React.createElement(ScrollTopButton), document.querySelector("#scrollTopButton"));
});

window.app = {
  helpers: {
    animationNonReactChart
  }
};
